(() => {
  let applying = false;

  const one = (selector, root = document) =>
    root.querySelector(selector);

  const all = (selector, root = document) =>
    [...root.querySelectorAll(selector)];

  const text = (element, value) => {
    if (
      element &&
      value !== undefined &&
      value !== null &&
      element.textContent !== String(value)
    ) {
      element.textContent = value;
    }
  };

  const href = (element, value) => {
    if (
      element &&
      value &&
      element.getAttribute('href') !== value
    ) {
      element.setAttribute('href', value);
    }
  };

  const photo = (element, url, alt = '') => {
    if (!element || !url) return;

    let image = element.querySelector(
      'img[data-shopify-image]'
    );

    if (!image) {
      element.innerHTML = '';

      image = document.createElement('img');
      image.setAttribute('data-shopify-image', '');
      image.className = 'h-full w-full object-cover';

      element.appendChild(image);
    }

    if (image.getAttribute('src') !== url) {
      image.setAttribute('src', url);
    }

    image.alt = alt || '';
  };

  const configs = () => {
    const output = {};

    all('[data-lilly-config]').forEach((element) => {
      try {
        output[element.dataset.lillyConfig] = JSON.parse(
          element.textContent
        );
      } catch (error) {
        console.warn(
          `Unable to read ${element.dataset.lillyConfig} settings.`,
          error
        );
      }
    });

    return output;
  };

  const setFirstTextNode = (element, value) => {
    if (!element || value === undefined || value === null) {
      return;
    }

    const node = [...element.childNodes].find(
      (item) =>
        item.nodeType === Node.TEXT_NODE &&
        item.textContent.trim()
    );

    if (node && node.textContent !== String(value)) {
      node.textContent = String(value);
    }
  };

  function apply() {
    if (applying || !one('#root > *')) return;

    applying = true;

    try {
      const config = configs();

      /*
       * HEADER
       */
      if (config.header) {
        const logo = one('header a[href="#top"]');

        if (logo && config.header.logo) {
          const parts = config.header.logo.split('·');

          const html =
            `${parts[0] || ''}` +
            '<span class="text-primary">·</span>' +
            `${parts[1] || ''}`;

          if (logo.innerHTML !== html) {
            logo.innerHTML = html;
          }
        }

        href(
          one('header a[target="_blank"]'),
          config.header.instagram
        );
      }

      /*
       * HERO
       */
      if (config.hero) {
        const root = one('#top');

        text(
          one('span.font-mono-data', root),
          config.hero.eyebrow
        );

        const heading = one('h1', root);

        setFirstTextNode(heading, config.hero.heading);
        text(one('h1 span', root), config.hero.italic);
        text(one('h1 + p', root), config.hero.description);

        text(
          one('a[href="#patterns"]', root),
          config.hero.button
        );

        href(
          one('a[target="_blank"]', root),
          config.hero.instagram
        );

        photo(
          one('[data-cursor="hot"] > div', root) ||
            one('[data-cursor="hot"]', root),
          config.hero.image,
          config.hero.heading
        );
      }

      /*
       * DIGITAL PATTERNS — SUPPORTS UP TO 7 CARDS
       */
      if (config.patterns) {
  const root = one('#patterns');

  text(one('h2', root), config.patterns.heading);

  text(
    one('.md\\:items-end > p', root),
    config.patterns.description
  );

  const patterns = (config.patterns.items || []).slice(0, 7);

  let cards = all('article', root);
  const grid = cards[0]?.parentElement;

  /*
   * Create enough cards for all seven Shopify blocks.
   */
  if (grid && cards.length > 0) {
    while (cards.length < patterns.length) {
      const newCard = cards[0].cloneNode(true);

      newCard.setAttribute(
        'data-shopify-pattern-card',
        ''
      );

      /*
       * Cloned cards need their own hover behaviour.
       */
      const overlay = one(
        ':scope > div.absolute',
        newCard
      );

      if (overlay) {
        overlay.classList.remove('opacity-100');
        overlay.classList.add('opacity-0');

        newCard.addEventListener('mouseenter', () => {
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
        });

        newCard.addEventListener('mouseleave', () => {
          overlay.classList.remove('opacity-100');
          overlay.classList.add('opacity-0');
        });
      }

      grid.appendChild(newCard);
      cards = all('article', root);
    }
  }

  cards.forEach((card, index) => {
    const pattern = patterns[index];

    if (!pattern) {
      card.style.display = 'none';
      return;
    }

    card.style.removeProperty('display');

    text(one('h3', card), pattern.name);
    text(one('h3 + span', card), pattern.price);

    const detailsRow = one('dl', card);

if (
  detailsRow &&
  !one('[data-pattern-difficulty]', detailsRow)
) {
  detailsRow.innerHTML = `
  <div class="border-r border-foreground/15 px-4 py-2">
    <div class="text-foreground/45">
      Difficulty
    </div>

    <div data-pattern-difficulty>
    </div>
  </div>

  <div class="px-4 py-2 flex flex-col justify-center">
    <div class="text-foreground/45">
      Scale
    </div>

    <div
      class="flex items-center gap-1"
      data-pattern-stars
      aria-label="Difficulty scale"
    ></div>
  </div>
`;
}

text(
  one('[data-pattern-difficulty]', card),
  pattern.difficulty
);

const starsContainer = one(
  '[data-pattern-stars]',
  card
);

if (starsContainer) {
  const rating = Math.max(
    1,
    Math.min(
      5,
      Number(pattern.difficulty_stars) || 1
    )
  );

  if (
    starsContainer.getAttribute('data-rating') !==
    String(rating)
  ) {
    starsContainer.setAttribute(
      'data-rating',
      String(rating)
    );

    starsContainer.innerHTML = '';

    for (let star = 1; star <= 5; star += 1) {
      const starElement = document.createElement('span');

      if (star <= rating) {
      starElement.textContent = '★';
      starElement.className =
      'text-lg leading-none text-foreground';
      } else {
  starElement.textContent = '☆';
  starElement.className =
    'text-lg leading-none text-foreground/25';
}

      starElement.setAttribute('aria-hidden', 'true');
      starsContainer.appendChild(starElement);
    }
  }
}

    /*
     * Update the brown Supplies Needed box.
     */
    const suppliesList = one(
      ':scope > div.absolute ul',
      card
    );

    if (suppliesList) {
      const supplies = String(pattern.supplies || '')
        .split('\n')
        .map((item) => item.trim())
        .filter(Boolean);

      suppliesList.innerHTML = '';

      supplies.forEach((supply) => {
        const listItem = document.createElement('li');

        listItem.className =
          'font-mono-data text-[12px]';

        listItem.textContent = `+ ${supply}`;

        suppliesList.appendChild(listItem);
      });
    }

    href(one('a', card), pattern.link);

    photo(
      one(':scope > div', card),
      pattern.image,
      pattern.name
    );
  });
}

      /*
       * FEATURED KIT
       */
      if (config.kit) {
        const root = one('#kit');

        text(one('h2', root), config.kit.heading);

        text(
          one('h2 + p', root),
          config.kit.description
        );

        text(
          one('.text-4xl.font-bold', root),
          config.kit.price
        );

        href(one('a', root), config.kit.link);

        const imageSlots = all(
          '.grid.grid-cols-2 > div > div:first-child',
          root
        );

        imageSlots.forEach((element, index) => {
          photo(
            element,
            config.kit.images?.[index],
            `Kit image ${index + 1}`
          );
        });
      }

      /*
       * PROJECT GALLERY
       */
      if (config.gallery) {
        const root = one('#gallery');

        text(one('h2', root), config.gallery.heading);

        all('figure', root).forEach((figure, index) => {
          const project = config.gallery.items?.[index];

          if (!project) {
            figure.style.display = 'none';
            return;
          }

          figure.style.removeProperty('display');

          text(
            one('figcaption span:first-child', figure),
            project.title
          );

          text(
            one('figcaption span:last-child', figure),
            project.note
          );

          photo(
            one(':scope > div', figure),
            project.image,
            project.title
          );
        });
      }

      /*
       * YARN
       */
      if (config.yarn) {
        const root = one('#yarn');

        all('.animate-marquee > span', root).forEach(
          (element) => {
            const star = one('span', element);
            const value = `${config.yarn.marquee} `;

            if (
              element.firstChild &&
              element.firstChild.textContent !== value
            ) {
              element.firstChild.textContent = value;
            }

            if (star && element.lastChild !== star) {
              element.appendChild(star);
            }
          }
        );

        const heading = one('h2', root);

        setFirstTextNode(heading, config.yarn.heading);
        text(one('h2 span', root), config.yarn.italic);

        text(
          one('h2 + p', root),
          config.yarn.description
        );
      }

      /*
       * MY STORY
       */
      if (config.story) {
        const root = one('#story');
        const heading = one('h2', root);

        setFirstTextNode(heading, config.story.heading);
        text(one('h2 span', root), config.story.italic);

        const copy = one('h2 + div', root);

        if (
          copy &&
          config.story.text !== undefined &&
          config.story.text !== null &&
          copy.innerHTML !== config.story.text
        ) {
          copy.innerHTML = config.story.text;
        }

        photo(
          one('.max-w-sm > div', root),
          config.story.image,
          'Lilly at work'
        );
      }

      /*
       * MAILING LIST
       */
      if (config.mailing) {
        const root = one('#mailing-list');

        text(one('h2', root), config.mailing.heading);

        text(
          one('h2 + p', root),
          config.mailing.description
        );

        text(one('button', root), config.mailing.button);
      }

      /*
       * FOOTER
       */
      if (config.footer) {
        const root = one('footer');

        text(
          one('.text-sm', root),
          config.footer.description
        );

        href(
          one('a[target="_blank"]', root),
          config.footer.instagram
        );

        const bottomText = all('.mt-6 > p', root);

        if (
          bottomText[0] &&
          config.footer.copyright
        ) {
          bottomText[0].textContent =
            `© ${new Date().getFullYear()} ` +
            config.footer.copyright;
        }

        text(bottomText[1], config.footer.care);
      }
    } catch (error) {
      console.warn(
        'Unable to apply Shopify section settings.',
        error
      );
    } finally {
      applying = false;
    }
  }

  let scheduled = false;

  const scheduleApply = () => {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const observer = new MutationObserver(scheduleApply);

  const startBridge = () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    scheduleApply();

    /*
     * Keeps text and images synchronized with the Shopify editor.
     */
    window.setInterval(apply, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startBridge,
      { once: true }
    );
  } else {
    startBridge();
  }

  document.addEventListener(
    'shopify:section:load',
    scheduleApply
  );

  document.addEventListener(
    'shopify:section:select',
    scheduleApply
  );

  document.addEventListener(
    'shopify:section:deselect',
    scheduleApply
  );

  document.addEventListener(
    'shopify:block:select',
    scheduleApply
  );

  document.addEventListener(
    'shopify:block:deselect',
    scheduleApply
  );
})();